<hr class="bar-agendaco">
<div class="row">
    <div class="col-xs-1  imagen-move-agendaco">
        <img src="https://www.woden.com.co/woden-logo.png">
    </div>
    <div *ngIf="this.customer.name == 'CLARO'" class="col-xs-7 title-move-agendaco">
        <h4><b>Agenda la recolección sin costo de módems y de codificadores <span class="color-tittle-claro-agendaco">CLARO</span> que ya no usas</b></h4>
    </div>
    <div *ngIf="this.customer.name == 'ETB'" class="col-xs-7 title-move-agendaco">
        <h4><b>Agenda la recolección sin costo de módems y de codificadores <span class="color-tittle-etb-agendaco">ETB</span> que ya no usas</b></h4>
    </div>
    <div *ngIf="this.customer.name == 'TIGO'" class="col-xs-7 title-move-agendaco">
        <h4><b>Agenda la recolección sin costo de módems y de codificadores <span class="color-tittle-tigo-agendaco">TIGO</span> que ya no usas</b></h4>
    </div>
    <div *ngIf="this.customer.name == 'DIRECTV'" class="col-xs-7 title-move-agendaco">
        <h4><b>Agenda la recolección sin costo de módems y de codificadores <span class="color-tittle-directv-agendaco">DIRECTV</span> que ya no usas</b></h4>
    </div>
</div>
<div>
    <hr class="bar-seccion-agendaco">
</div>
<div class="col-sm-5 fluid" >
    <div class="row ">
        <img class="image-font-agendaco" src="./assets/imagenes agenda virtual/homeAgendamiento.png">
    </div>
</div>
<div class="col-sm-7 fluid">
    <div class="row">
        <h5 class="text-center-agendaco"><b>{{title1}}</b></h5>
        <form #agendaForm="ngForm" name="agendaForm">
            <div class="row input-agenda">
                <div *ngIf="customer.id==2" class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title3}}</label>
                    <input type="text" class="form-control" #scnc="ngModel" name="scnc" [(ngModel)]="schedule.company"
                        required>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title2}}</label>
                    <input type="text" class="form-control" #scce="ngModel" name="scce" [(ngModel)]="identification"
                        (change)="getSubscriber(identification)" required>
                </div>
                <div *ngIf="customer.id==2" class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco"> {{title4}} </label>
                    <input type="text" class="form-control" #scna="ngModel" name="scna" [(ngModel)]="schedule.name" required>
                </div>
                <div *ngIf="customer.id!=2" class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco"> {{title4}} </label>
                    <input type="text" class="form-control" #scna="ngModel" name="scna" [(ngModel)]="schedule.name" required>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title5}} </label>
                    <input type="email" class="form-control" #scco="ngModel" name="scco" [(ngModel)]="schedule.email"
                        pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$">
                </div>
            </div>
            <br>
            <div class="row input-agenda">
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title6}}</label>
                    <input type="number" class="form-control" #scph="ngModel" name="scph" [(ngModel)]="tel">
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title7}}</label>
                    <input type="number" class="form-control" #scphm="ngModel" name="scphm" [(ngModel)]="telMovil"
                        requerid>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title8}} </label>
                    <input type="text" class="form-control" #scad="ngModel" name="scad" [(ngModel)]="schedule.address"
                        (change)="changeAddress()" id="autocomplete" onFocus="geolocate()" required>
                </div>
            </div>
            <br>
            <div class="row input-agenda">
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title9}}</label>
                    <p-dropdown #scde="ngModel" name="scde" [(ngModel)]="schedule.departmentId"
                        [options]="dropdownDepartments" (onChange)="changeDepartment()"
                        [style]="{'width': '100%','height': '34px'}" [disabled]="!validateLocation" required>
                    </p-dropdown>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title10}} </label>
                    <p-dropdown #scci="ngModel" name="scci" [(ngModel)]="citySelected" (onChange)="changeCity()"
                        [options]="dropdownCities" [style]="{'width': '100%','height': '34px'}"
                        [disabled]="!validateLocation" required></p-dropdown>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title11}} </label>
                    <input type="text" class="form-control" placeholder="">
                </div>
            </div>
            <br>
            <div class="row input-agenda">
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco"> {{title12}} </label>
                    <p-calendar *ngIf="customer.id != 13 && customer.id != 4 && customer.id != 3" #scdp="ngModel"
                        name="scdp" [(ngModel)]="schedule.datePickup" tabindex="0" [minDate]="minDate"
                        [maxDate]="maxDate" [disabledDates]="invalidDates" [disabledDays]="[0,6]" [readonlyInput]="true"
                        [numberOfMonths]="2" showIcon="true" [disabled]="!validateDate"
                        [inputStyle]="{'width': '100%','height': '34px'}" [style]="{'width': '100%'}" required>
                    </p-calendar>
                    <p-calendar *ngIf="customer.id == 13 || customer.id == 4 || customer.id == 3" #scdp="ngModel"
                        name="scdp" [(ngModel)]="schedule.datePickup" tabindex="0" [minDate]="minDate"
                        [maxDate]="maxDate" [disabledDates]="invalidDates" [disabledDays]="[0,7]" [readonlyInput]="true"
                        [numberOfMonths]="2" showIcon="true" [disabled]="!validateDate"
                        [inputStyle]="{'width': '100%','height': '34px'}" [style]="{'width': '100%'}" required>
                    </p-calendar>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title13}}</label>
                    <p-dropdown #scwd="ngModel" name="scwd" [(ngModel)]="schedule.workSheduleId"
                        [options]="dropdownCustomerSchedule" [style]="{'width': '100%', 'height': '34px'}"
                        [disabled]="!validateSchedule" required></p-dropdown>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4 col-xl-4">
                    <label class="text-label-agendaco">{{title14}} </label>
                    <input type="number" class="form-control" placeholder="">
                </div>
            </div>
            <br>
            <div class="row input-agenda">
                <div class="col-xs-8 col-md-8 col-lg-8 col-xl-8">
                    <textarea class="form-control form-control-agendaco" #scob="ngModel" name="scob"
                        [(ngModel)]="schedule.observation" placeholder="{{title16}} "></textarea>
                </div>
                <div class="col-xs-3 col-md-3 col-lg-3 col-xl-3">
                    <button *ngIf="customer.name=='CLARO' || customer.name=='CLARO - PERU'"
                        class="btn button-agendaco btn-block" (click)="createSchedule()"
                        [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                        Enviar
                    </button>
                    <button *ngIf="customer.name=='CLAROMOVIL'" class="btn button-agendaco btn-block"
                        (click)="createSchedule()" [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                        Enviar
                    </button>
                    <button *ngIf="customer.name=='ETB'" class="btn button-agendaco btn-block" (click)="createSchedule()"
                        [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                        Enviar
                    </button>
                    <button
                        *ngIf="customer.name=='TIGO' || customer.name=='TIGO - PANAMA' || customer.name==='TIGO SALVADOR'"
                        class="btn button-agendaco btn-block" (click)="createSchedule()"
                        [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                        Enviar
                    </button>
                    <button *ngIf="customer.name=='DIRECTV'" class="btn button-agendaco btn-block"
                        (click)="createSchedule()" [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                        Enviar
                    </button>
                    <button *ngIf="view" class="btn button-agendaco btn-block" (click)="createSchedule()"
                        [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                        Enviar
                    </button>
                </div>
            </div>
            <br>
            <div *ngIf="customer.sendInformation" class="row input-agenda" style="margin-bottom: 0px;">
                <div class="col-md-1 col-sm-1 col-xs-1">
                    <p-checkbox #scap="ngModel" name="scap" [(ngModel)]="schedule.acceptP" binary="true" required></p-checkbox>
                </div>
                <div class="col-md-11 col-sm-11 col-xs-11">
                    <h5 class="politic-agendaco text-info-agendaco">He leido y acepto la <a href={{urlpolicy}} target="blank" class="politic-color-agenda ">Política de Tratamiento de
                            datos </a></h5>
                </div>
            </div>
            <div *ngIf="customer.sendInformation" class="row input-agenda" style="margin-bottom: 0px;">
                <div class="col-md-1 col-sm-1 col-xs-1">
                    <p-checkbox #scae="ngModel" name="scae" [(ngModel)]="schedule.acceptE" binary="true">
                    </p-checkbox>
                </div>
                <div class="col-md-11 col-sm-11 col-xs-11">
                    <h5 class="politic-agendaco text-info-agendaco"> Autorizo a <strong class="politic-agendaco">WODEN</strong> enviar contenido informativo, comercial y de
                        marketing a mi correo electrónico.</h5>
                </div>
            </div>
            <input style="display: none;" type="file" #uploadF (change)="loadFile($event)"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
            <div *ngIf="customer.id==2">
                <button class="btn btn-success" (click)="uploadF.click()">
                    <span class="fa fa-upload" aria-hidden="true"></span>
                </button>
                <div class="col-lg-12">
                    <p-table #dt [columns]="cols" [value]="scheduleSerie" [resizableColumns]="true"
                        columnResizeMode="expand" [autoLayout]="true" [paginator]="true" [rows]="10" [first]="first">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th *ngFor="let col of columns">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr>
                                <td *ngFor="let col of columns">
                                    {{rowData[col.field]}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            Total Registros: {{scheduleSerie?.length}}
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="!customer.publicity" class="col-md-2 col-sm-2 col-xs-12" id="bannerDer">
        <div *ngIf="citySelected != undefined" class="col-md-11 col-sm-11 col-xs-12" id="entrega"
            style="color:black; font-weight: bold;">
            <p *ngIf="citySelected.id" class="text-info-agendaco input-agenda">Condiciones de la entrega:</p>
            <h6 *ngIf="citySelected.id" class="text-info-agendaco input-agenda" style="margin-left: -14px; margin-right: 22px;">Según su
                ubicación, la recolección se realizará <strong>{{this.citySelected.categoryDay}} días </strong>
                hábiles después de la programación.</h6>
        </div>
    </div>  
    <div *ngIf="customer.foot1!=''" class="col-lg-10 col-md-10 col-sm-12 col-xs-12  col-lg-offset-1 col-md-offset-1">
        <div id="footer1" class="text-info-agendaco" style="margin-bottom: 10px;"></div>
    </div>
    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12  col-lg-offset-1 col-md-offset-1">
        <div id="footer2" class="text-info-agendaco"></div>
    </div>
    <div *ngIf="customer.publicity"  class="col-xs-12 col-md-12 col-lg-12 col-xl-12" id="bannerDer">
        <div *ngIf="citySelected != undefined" class="col-md-11 col-sm-11 col-xs-12" id="entrega"
            style="color:rgb(136, 136, 136); font-weight: bold;">
            <a  class="text-info-agendaco input-agenda">Condiciones de la entrega:</a>
            <h6  class="text-info-agendaco input-agenda">Según su
                ubicación, la recolección se realizará <strong>{{this.citySelected.categoryDay}} días </strong>
                hábiles después de la programación.</h6>
        </div>
    </div>
    <div *ngIf="customer.whatsapp!=''" style="position: fixed;bottom:5px;left:20px;z-index:1000;margin-left: 85%;">
        <a href={{whatsapp}} target="_blank"><img src="./assets/images/whatsapp.png" width="55"></a>
    </div>
</div>

